// @ts-nocheck
import { Col, Divider, Row, SelectPicker, Table, Button, Input, ButtonToolbar, IconButton, Panel, FlexboxGrid } from 'rsuite';
import { ControlCol, ControlRow, CustomInput } from './costing-page';
import React, { useEffect, useState } from 'react';
import { FirstGridType } from './types';
const { Column, HeaderCell, Cell } = Table;
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import ArrowUpIcon from '@rsuite/icons/ArrowUp';

export const FirstGrid = React.memo(
  ({
    handleAddRow,
    updatingCalc,
    setUpdatingCalc,
    handleFieldUpdate,
    columns,
    state,
    costingTableData,
    buyerData,
    fieldData,
    handleFieldDataValue,
    calculateMultiplication,
    showTables,
    setReload,
    setReload2,
    productData,
    setReFetchBuyerName
  }: FirstGridType) => {
    const chiefMaterialData = state?.Material?.filter(item => item.Type === 'cmaterial').filter(item => costingTableData.CostingMaterial.find(element => element.chiefmaterial == item.label));
    const handleReload = () => {
      if (
        showTables.accessories ||
        showTables.packing ||
        showTables.material ||
        showTables.wood ||
        showTables.process
      ) {
        setReload(prev => !prev);
      } else {
        setReload2(prev => !prev);
      }
    };
    const { Height, Length, Width, SizeUnit } = productData;

    const convertedHeight = SizeUnit === 'cm' ? Height / 2.54 : Height;
    const convertedLength = SizeUnit === 'cm' ? Length / 2.54 : Length;
    const convertedWidth = SizeUnit === 'cm' ? Width / 2.54 : Width;


    useEffect(() => {
      const highestValue = Math.max(
        parseFloat(convertedHeight),
        parseFloat(convertedLength),
        parseFloat(convertedWidth)
      ).toFixed(2);
      if (!fieldData.size && fieldData.size !== '') {
        handleFieldDataValue('size', highestValue);
      }
    }, [fieldData.size])


    const [setshowMaterialDetails, setSetshowMaterialDetails] = useState(false);
    return (
      <>
        <Row gutter={24} style={{ boxShadow: '0px 0px 4px -1px grey', borderRadius: '6px', marginBottom: '10px', width: '99.8%' }} >
          <Col lg={8} style={{ marginBottom: '10px', marginTop: '10px' }}>
            {productData.costingFor.for == 'buyer' ? (
              <ControlRow
                label="Buyer Name"
                control={
                  <SelectPicker
                    data={buyerData.length ? buyerData : []}
                    size="xs"
                    disabled={productData.costingFor.for != 'buyer' ? true : false}
                    value={fieldData.buyername}
                    style={{ width: '40%' }}
                    readOnly={!productData.isEdit}
                    onChange={value => {
                      handleFieldDataValue('buyername', value);
                      setReFetchBuyerName(value);
                    }}
                  />
                }
              />
            ) : (
              <ControlRow label="For factory" control={<Input size="xs" value="Factory" />} />
            )}
          </Col>

          <Col lg={8} style={{ marginBottom: '10px', marginTop: '10px' }}>
            <ControlRow
              label="Costing Type"
              control={
                <SelectPicker
                  searchable={false}
                  data={[
                    { label: 'Draff', value: 'Draff' },
                    { label: 'Revision', value: 'Revision' }
                  ]}
                  readOnly={!productData.isEdit}
                  size="xs"
                  cleanable={false}
                  style={{ width: '60%' }}
                  value={fieldData?.costingtype}
                  onChange={value => handleFieldDataValue('costingtype', value)}
                />
              }
            />
          </Col>
          <Col lg={8} style={{ marginBottom: '10px', marginTop: '10px' }}>
            <ControlRow
              label="Target Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="targetCost"
                  style={{ width: '60%' }}
                  value={String(fieldData.targetCost)}
                  onChange={value => {
                    if (showTables.material || showTables.wood) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                    handleFieldDataValue('targetCost', value);
                  }}
                />
              }
            />
          </Col>
        </Row>
        <Row gutter={20} style={{ boxShadow: '0px 0px 4px -1px grey', borderRadius: '6px', paddingTop: '8px', width: '99.8%' }}>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Net Weight"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.000"
                  name="Netwgt"
                  value={updatingCalc.NetWeight ? fieldData.Netwgt : fieldData.Netwgt.toFixed(3)}
                  // value={String(fieldData.Netwgt) || 0}
                  disabled={showTables.material || showTables.wood}
                  onChange={value => {
                    handleFieldDataValue('Netwgt', value / 1);
                    setReload(prev => !prev);
                  }}
                  onFocus={() => {
                    handleFieldUpdate("NetWeight", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("NetWeight", false)
                  }
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Rate/Kg"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="perkgrate"
                  value={String(updatingCalc.RateperKg
                    ? Number(fieldData.perkgrate)
                    : (fieldData?.perkgrate || 0).toFixed(2)) || '0.00'}
                  // value={String(fieldData.perkgrate) || 0}
                  disabled={showTables.material || showTables.wood}
                  onChange={value => {
                    handleFieldDataValue('perkgrate', value / 1);
                    setReload(prev => !prev);
                  }}
                  onFocus={() => {
                    handleFieldUpdate("RateperKg", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("RateperKg", false)
                  }
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Item Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  readOnly
                  name="itemcost"
                  value={String(fieldData.itemcost.toFixed(2))}
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
            label={'Size/inch'}
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="size"
                  value={String(updatingCalc.Size
                    ? Number(fieldData.size)
                    : Number(fieldData?.size)?.toFixed(3)) || '0.00'}
                  disabled={showTables.process}
                  onChange={value => {
                    handleFieldDataValue('size', value);
                    
                    // // Handle clearing and calculations
                    // if (value === '' || fieldData.rate === undefined) {
                    //   handleFieldDataValue('size', ''); // Explicitly clear the value
                    // } else {
                    //   calculateMultiplication('finishcost', value, fieldData.rate);
                    // }
                    setReload(prev => !prev);
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Size", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Size", false)
                  }
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Rate/inch"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="rate"
                  value={updatingCalc.Rateperinch ? Number(fieldData.rate) : (Number(fieldData?.rate)).toFixed(2)}
                  // value={String(fieldData.rate) || 0}
                  disabled={showTables.process}
                  onChange={value => {
                    handleFieldDataValue('rate', value);
                    
                    // if (fieldData.size || fieldData.rate) {
                    //   calculateMultiplication('finishcost', fieldData.size, value);
                    // }
                    setReload(prev => !prev);
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Rateperinch", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Rateperinch", false)
                  }
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Finish Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="finishcost"
                  readOnly
                  value={String(fieldData.finishcost.toFixed(2))}
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label={"Accessories Cost " }
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="accessorycost"
                  disabled={showTables.accessories}
                  value={String(updatingCalc.Accessories
                    ? Number(fieldData.accessorycost)
                    : (fieldData?.accessorycost).toFixed(2)) || '0.00'}
                  // value={String(fieldData.accessorycost) || 0}
                  onChange={value => {
                    handleFieldDataValue('accessorycost', value / 1);
                    if (showTables.accessories) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Accessories", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Accessories", false)
                  }

                />
              }
            />
          </Col>
          {/* <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Wiring Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="wiringcost"
                  value={String(updatingCalc.Wiring
                    ? Number(fieldData.wiringcost)
                    : (fieldData?.wiringcost || 0).toFixed(2)) || '0.00'}
                  // value={String(fieldData.fittingcost) || 0}
                  onChange={value => {
                    handleFieldDataValue('wiringcost', value / 1);
                    if (
                      showTables.accessories ||
                      showTables.packing ||
                      showTables.material ||
                      showTables.wood ||
                      showTables.process
                    ) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Wiring", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Wiring", false)
                  }
                />
              }
            />
          </Col> */}
          {/* <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Fitting Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="fittingcost"
                  value={String(updatingCalc.Fitting
                    ? Number(fieldData.fittingcost)
                    : (fieldData?.fittingcost || 0).toFixed(2)) || '0.00'}
                  // value={String(fieldData.fittingcost) || 0}
                  onChange={value => {
                    handleFieldDataValue('fittingcost', value / 1);
                    if (
                      showTables.accessories ||
                      showTables.packing ||
                      showTables.material ||
                      showTables.wood ||
                      showTables.process
                    ) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Fitting", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Fitting", false)
                  }
                />
              }
            />
          </Col> */}
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Polish Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="polishcost"
                  value={String(updatingCalc.Polish
                    ? Number(fieldData.polishcost)
                    : (fieldData?.polishcost || 0).toFixed(2)) || '0.00'}
                  // value={fieldData.polishcost ? String(fieldData.polishcost) : 0}
                  onChange={value => {
                    handleFieldDataValue('polishcost', value / 1);
                    if (
                      showTables.accessories ||
                      showTables.packing ||
                      showTables.material ||
                      showTables.wood ||
                      showTables.process
                    ) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Polish", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Polish", false)
                  }
                />
              }
            />
          </Col>
          {/* <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Packing Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="packingcost"
                  value={String(updatingCalc.Packing
                    ? Number(fieldData.packingcost)
                    : (fieldData?.packingcost || 0).toFixed(2)) || '0.00'}
                  // value={String(fieldData.packingcost) || 0}
                  disabled={showTables.packing}
                  onChange={value => {
                    handleFieldDataValue('packingcost', value / 1);

                    if (showTables.packing) {
                      setReload(prev => !prev);
                    } else {
                      setReload2(prev => !prev);
                    }
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Packing", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Packing", false)
                  }
                />
              }
            />
          </Col> */}
          {/* <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Inner Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  name="innercost"
                  // value={updatingCalc.InnerCost? Number(fieldData.innercost):  Number(fieldData?.innercost || 0).toFixed(2) || '0.00'}
                  value={String(fieldData?.innercost) || 0}
                  onChange={value => {
                    handleFieldDataValue('innercost', value / 1);
                    handleReload();
                  }}
                  onFocus={() => {
                    handleFieldUpdate("InnerCost", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("InnerCost", false)
                  }
                />
              }
            />
          </Col>
          <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Master Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  value={String(fieldData?.mastercost) || 0}
                  onChange={value => {
                    handleFieldDataValue('mastercost', value / 1);
                    handleReload();
                  }}
                  onFocus={() => {
                    handleFieldUpdate("MasterCost", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("MasterCost", false)
                  }
                />
              }
            />
          </Col> */}
          {/* <Col lg={4} style={{ marginBottom: '10px' }}>
            <ControlCol
              label="Shipping Cost"
              control={
                <CustomInput
                  step={null}
                  placeholder="0.00"
                  value={String(fieldData?.shippingcost) || 0}
                  onChange={value => {
                    handleFieldDataValue('shippingcost', value / 1);
                    handleReload();
                  }}
                  onFocus={() => {
                    handleFieldUpdate("Shipping", true)
                  }}
                  onBlur={() =>
                    handleFieldUpdate("Shipping", false)
                  }
                />
              }
            />
          </Col> */}
        </Row>
        <Divider style={{ margin: '10px 0' }} />
        {showTables.material && (
          <>
            <Table
              bordered
              cellBordered
              autoHeight
              data={costingTableData['CostingMaterial']}
              height={costingTableData['CostingMaterial'].length ? null : 40}
            >
              {columns.map(({ label, key, renderCell, fixed }) => {
                return (
                  <Column
                    fixed={fixed}
                    key={key}
                    width={label == 'S.no' ? 50 : label == 'Add Material' ? 150 : 80}
                    flexGrow={label == 'S.no' ? null : 1}
                  >
                    <HeaderCell
                      style={{
                        fontSize: '11px',
                        fontWeight: 'bold',
                        padding: label == 'Add Material' ? '5px 0 0 10px' : null
                      }}
                    >
                      {label == 'Add Material' ? (
                        <ButtonToolbar>

                          <Button
                            size="sm"
                            active
                            style={{ cursor: 'pointer', color: '#8e8e93', fontSize: '11px' }}
                            onClick={() => handleAddRow('CostingMaterial')}
                          >
                            Add Material
                          </Button>
                          <IconButton
                            size="sm"
                            active
                            style={{ cursor: 'pointer', fontSize: '11px' }}
                            icon={setshowMaterialDetails ? <ArrowDownIcon /> : <ArrowUpIcon />}
                            onClick={() => setSetshowMaterialDetails(!setshowMaterialDetails)}></IconButton>
                        </ButtonToolbar>
                      ) : (
                        label
                      )}
                    </HeaderCell>
                    <Cell
                      dataKey={key}
                      style={{ padding: key == 'addMaterial' ? '8px 0 0 0' : null }}
                    >
                      {(rowData, index) => (renderCell ? renderCell(rowData, index) : rowData[key])}
                    </Cell>
                  </Column>
                );
              })}
            </Table >
            {setshowMaterialDetails && costingTableData.CostingMaterial.length > 0 && chiefMaterialData.length > 0 && (
              <FlexboxGrid style={{
                padding: "5px",
                flexDirection: "column",
                justifyContent: 'center'
              }}>
                <h6>Material Summary</h6>
                <Table bordered cellBordered width={450} rowHeight={30} autoHeight data={chiefMaterialData}>
                  <Column width={150} align="center" fullText>
                    <HeaderCell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }}>
                      <b>Chief Material</b>
                    </HeaderCell>
                    <Cell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }} dataKey="label" />
                  </Column>
                  <Column width={150} align="center" fullText>
                    <HeaderCell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }}>
                      <b>Total Weight/Qty</b>
                    </HeaderCell>
                    <Cell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }} >{rowData => costingTableData.CostingMaterial.filter(item => item.chiefmaterial === rowData.label).reduce((acc, item) => acc + item.wgtqty, 0)}</Cell>
                  </Column>
                  <Column width={150} align="center" fullText>
                    <HeaderCell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }}>
                      <b>Total Material Cost</b>
                    </HeaderCell>
                    <Cell style={{ fontSize: '11px', fontWeight: 'bold', padding: '5px 0 0 10px' }} >{rowData => costingTableData.CostingMaterial.filter(item => item.chiefmaterial === rowData.label).reduce((acc, item) => acc + item.totalmaterialcost, 0)}</Cell>
                  </Column>
                </Table>

              </FlexboxGrid>
            )}
          </>
        )}
      </>
    );
  }
);
